var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":_vm.effect,"content":_vm.content,"placement":_vm.placement}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("content")],2),_vm._v(" "),_vm._t("btn")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398e2da3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltipBox.vue
// module id = null
// module chunks = 